import { useCurrentUser } from '@artic/api-client';
import { useEffect } from 'react';
import { useIntercom } from 'react-use-intercom';

export function IntercomIdentity() {
  const { user } = useCurrentUser();
  const { update } = useIntercom();

  useEffect(() => {
    const name =
      user.profile_name ??
      [user.profile_first_name, user.profile_last_name].filter(Boolean).join(' ');
    update({ userId: user.id, email: user.email, ...(name ? { name } : {}) });
  }, [
    update,
    user.id,
    user.email,
    user.profile_name,
    user.profile_first_name,
    user.profile_last_name,
  ]);

  return null;
}
